import React, { Component } from "react";
import { Link } from 'react-router-dom'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import 
import service from '../../services'

//moment import 
import moment from 'moment'

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//Loader import
import Loader from "../loader";

//sweet alert
import swal from 'sweetalert';

// Images import
import serachIcon from "../../assets/images/search.svg";
import close from "../../assets/images/close.svg";
import cloud from "../../assets/images/cloud.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import background from "../../assets/images/background.jpg";
import DeletefileIcon from "../../icons/DeletefileIcon";
import PopUpCustomAll from "../fpg/create/popUpCustomAll";
import ErrorPopUp from "../errorPopUp";
import EditIcon from '../../icons/EditIcon';

import LockCloseIcon from '../../icons/LockCloseIcon';
import LockIcon from '../../icons/LockIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import commonImage from "../../commonImage";

let sub;

const mapStateToProps = state => ({
    getPartnerDetails: state.getPartnerDetails,
    getLoginRole: state.getLoginRole
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let displayTypeData = []
class partnerViewEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDraggable: false,
            userForResendMail: [],
            emailLoader: false,
            resendMailPopup: false,
            email: '',
            contactFullName: '',
            lastName: '',
            partnerSubTitle: '',
            getAllPartnersDetails: [],
            getAllPartnersdocs: [],
            createPartnerPopup: false,
            changeTitleName: false,
            selectedDropdown: '',
            file: null,
            loaderFlag: false,
            instituteAssociate: false,
            disPartnerType: {
                All: true,
                general_sponsor: false,
                presenting_sponsor: false,
                media_sponsor: false,
                sustaining_sponsor: false,
                leadership_sponsor: false
            },
            partnerDispalyType: [
                { name: "All", value: true, pass: 'true' },
                { name: "Yes", value: false, pass: 'true' },
            ],

            id: '',
            searchField: '',
            imagePreloader: false,
            partnerTypeList: [
                { value: 'Select an Option', name: 'Select an Option' },
                { value: 'General Sponsor', name: 'General Sponsor' },
                { value: 'Presenting Sponsor', name: 'Presenting Sponsor' },
                { value: 'Sustaining Sponsor', name: 'Sustaining Sponsor' },
                { value: 'Media Sponsor', name: 'Media Sponsor' },
                { value: 'Leadership Sponsor', name: 'Leadership Sponsor' }
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 9999,
            currentPage: 1,
            // pagination variable diclaration end
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z ']*)$/i) || validator.helpers.testRegex(val, /^[-a-zA-Z s]+$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 . : , _ + @ & | ( )']*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                }
            }
        });
        this.apiserve = new service();
        this.onDragEnd = this.onDragEnd.bind(this)
    }

    componentDidMount = async () => {
        this.getAllPartnerView(this.state.offset, this.state.perPage);
        this.getAllPartner();
        this.setState({
            loaderFlag: true,
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        displayTypeData = []
    }

    getAllPartner = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "FestivalVillage|Partner|getList":
                    this.setState({
                        getAllPartnersDetails: response.data,
                        getAllPartnersdocs: response.data.docs
                    }, () => {
                        this.setState({
                            loaderFlag: false,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        })
                    })
                    break;
                case "FestivalVillage|Partner|create":
                    if (response.error) {
                        this.setState({
                            loaderFlag: false
                        })
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    } else {
                        this.setState({
                            createPartnerPopup: false
                        }, () => this.getAllPartnerView(this.state.offset, this.state.perPage),
                            this.setState({
                                loaderFlag: false,
                                partnerLogo: '',
                                contactFullName: '',
                                partnerType: '',
                                partnerName: '',
                                instituteAssociate: false
                            }),
                            this.apiserve.success('Partner user created successful.'))
                    }

                    break;
                case "deleteUser":
                    this.getAllPartnerView(this.state.offset, this.state.perPage);
                    break;
                case "FestivalVillage|blockUser":
                    this.getAllPartnerView(this.state.offset, this.state.perPage);
                    break;
                case "FestivalVillage|Partner|edit":
                    this.setState({
                        createPartnerPopup: false
                    }, () => this.getAllPartnerView(this.state.offset, this.state.perPage),
                        this.setState({ loaderFlag: false }),
                        this.apiserve.success('Partner user updated successful.')
                    )
                    break;
                case "loginUser":
                    if (response.error) {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    } else {
                        let data = response.data;
                        const newRole = data.userData.additionalRoles.filter(role => role !== "generalUser")[0];
                        data.user.role = newRole;
                        this.props.LoginRole(data)
                        this.props.BackToAdminFlag(true)
                        localStorage.setItem('loginToken', response.data.token)
                        localStorage.setItem('currentUserRole', data.user.role)
                        this.apiserve.sendevent("getUser", { id: response.data.user._id });
                    }
                    break;
                case "getUser":
                    this.props.ProfileName(response.data)
                    if (response.data.role === "partner") {
                        this.props.GetPartner(response.data)
                        this.props.history.push('/profile-partner-view')
                    }
                    break;
                case "FestivalVillage|getUserCsv":
                    if (!response.error) {
                        window.open(response.data.location)
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                case "FestivalVillage|sendMail":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            emailLoader: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                case "FestivalVillage|changeOrder":
                    if (!response.error) {
                        this.getAllPartnerView(this.state.offset, this.state.perPage)
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
            }
        });
    }

    getAllPartnerView = (skip, limit) => {
        const { getLoginRole } = this.props
        if (getLoginRole.user.role === 'admin') {
            var data = {
                // role: "partner",
                page: skip,
                limit: limit
            }
            if (displayTypeData && displayTypeData.length) {
                data.instituteAssociate = displayTypeData
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
        } else {
            var data = {
                // role: "partner",
                addedBy: getLoginRole.user._id,
                page: skip,
                limit: limit
            }
            if (displayTypeData && displayTypeData.length) {
                data.instituteAssociate = displayTypeData
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
        }

        this.apiserve.sendevent("FestivalVillage|Partner|getList", data);
    }

    createPartnersUser = async () => {
        this.setState({
            createPartnerPopup: true,
            changeTitleName: false,
            contactFullName: '',
            email: '',
            instituteAssociate: false,
            partnerLogo: "",
            partnerName: "",
        })
        this.validator.hideMessages();

    }

    closePartnerUser = () => {
        this.setState({
            createPartnerPopup: false,
            changeTitleName: false,
            contactFullName: "",
            lastName: "",
            partnerName: "",
            partnerLogo: "",
            instituteAssociate: false,
            resendMailPopup: false,
        })
        this.validator.hideMessages();

    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onInputChangeDropDown = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    submitFn = async (e) => {
        const { getLoginRole } = this.props
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true })
            if (this.state.changeTitleName) {
                let updatePartners = {
                    contactFullName: this.state.contactFullName,
                    email: this.state.email,
                    partnerName: this.state.partnerName,
                    partnerLogo: this.state.partnerLogo,
                    id: this.state.id,
                    instituteAssociate: this.state.instituteAssociate
                }
                this.apiserve.sendevent("FestivalVillage|Partner|edit", updatePartners);
            } else {
                let data = {
                    contactFullName: this.state.contactFullName,
                    email: this.state.email,
                    partnerName: this.state.partnerName,
                    contactFullName: this.state.contactFullName,
                    instituteAssociate: this.state.instituteAssociate,
                    partnerLogo: this.state.partnerLogo,
                }
                this.apiserve.sendevent("FestivalVillage|Partner|create", data);
            }

        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    editPartnersUser = async (item) => {
        this.setState({
            createPartnerPopup: true,
            changeTitleName: true,
            contactFullName: item.contactFullName,
            instituteAssociate: item.instituteAssociate,
            email: item.email,
            partnerName: item.partnerName,
            partnerLogo: item.partnerLogo,
            id: item._id,
        })
    }

    deletePartnersUser = async (item) => {

        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    swal("Your record has been deleted!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id
                    }
                    this.apiserve.sendevent("deleteUser", data);
                } else {
                    swal("Your record is safe!");
                }
            });


    }

    blockPartnersUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to block this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been block!", {
                        icon: "success"
                    });
                    let data = {
                        userId: item._id,
                        role: "partner",
                        isBlocked: true
                    }
                    this.apiserve.sendevent("FestivalVillage|blockUser", data);
                } else {
                    swal("Your record is unblock!");
                }
            });
    }

    unblockPartnersUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to unblock this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been unblock!", {
                        icon: "success"
                    });
                    let data = {
                        userId: item._id,
                        role: "partner",
                        isBlocked: false
                    }
                    this.apiserve.sendevent("FestivalVillage|blockUser", data);
                } else {
                    swal("Your record is block!");
                }
            });
    }

    changeRouteUser = (item) => {
        let data = {
            id: item._id
        }
        this.props.LoginUser(this.props.getLoginRole);
        this.apiserve.sendevent("loginUser", data);
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    onChangeFile(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUpload(file,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            });
        }
    }

    imageUpload = (file,img) => {
        this.setState({ imagePreloader: true })
        var fileSet = commonImage(file,false,'',img)

        fileSet.then((value) => {
                this.setState({
                    imagePreloader: false,
                    partnerLogo: value,
                });
            });
    };

    //displayPartnerType Wise Filter start
    displayPartnerType = (e, selectedInex) => {
        let index = selectedInex
        let event = e.target.checked

        let newDispPartnerType = [...this.state.partnerDispalyType]
        newDispPartnerType.forEach((key, i) => {
            if (index === 0) {
                if (i === 0) {
                    newDispPartnerType[index].value = event
                } else {
                    newDispPartnerType[i].value = false
                }
            } else {
                if (i === 0) {
                    if (displayTypeData && displayTypeData.length === 1 && !event) {
                        newDispPartnerType[i].value = true
                    } else {
                        newDispPartnerType[i].value = false
                    }
                } else {
                    newDispPartnerType[index].value = event
                }
            }

        });
        this.setState({
            ...this.state,
            partnerDispalyType: newDispPartnerType
        }, () => {
            if (index === 0 && event) {
                displayTypeData = []
            } else if (event) {
                displayTypeData = [...displayTypeData, this.state.partnerDispalyType[index].pass];
            } else {
                let tempArray = displayTypeData.filter((d) => d !== this.state.partnerDispalyType[index].pass);
                displayTypeData = tempArray;
            }
            this.getPartnarTypeDetails(this.state.offset, this.state.perPage);
        })

    };

    getPartnarTypeDetails = (skip, limit) => {
        this.setState({ loaderFlag: true })
        const partnerTypeDetails = {
            page: skip,
            limit: limit
        }
        if (displayTypeData && displayTypeData.length) {
            partnerTypeDetails.instituteAssociate = displayTypeData
        }
        this.apiserve.sendevent("FestivalVillage|Partner|getList", partnerTypeDetails);
    }
    //displayPartnerType Wise Filter end

    sendEmailPopup = (user) => {
        this.setState({
            userForResendMail: user,
            userContactFullName: user.contactFullName
        }, () => {
            this.setState({
                resendMailPopup: true
            })
        })
    }

    resendMail = () => {
        var data = {
            id: this.state.userForResendMail._id
        }
        this.setState({
            emailLoader: true
        })
        this.apiserve.sendevent("FestivalVillage|sendMail", data)
    }


    getPartnerTableHeadView = () => {
        const { partnerDispalyType } = this.state
        return (
            <tr>
                <th className="partnerName_d">Partner Name</th>
                <th className="" style={{ width: "200px" }}>Contact Full Name</th>
                <th className="lastName_d" style={{ width: "270px" }}>Contact Email</th>
                <th className="regOn_d" style={{ width: "150px" }}>Last Logged On</th>
                <th className="addOn_d" style={{ width: "150px" }}>Added On</th>
                <th className="" style={{ width: "220px" }}></th>
            </tr>
        )
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const { getAllPartnersdocs } = this.state
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.getAllPartnersdocs];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                userId: _id,
                sortIndex: i + 1,
            });
        });
        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.apiserve.sendevent('FestivalVillage|changeOrder', data)
        this.setState({ getAllPartnersdocs: arr });
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => {
            var data = {
                page: 1,
                limit: 9999,
            }
            if (this.state.searchField.length) {
                data = {
                    filter: this.state.searchField,
                }
            }
            if (displayTypeData && displayTypeData.length) {
                data.instituteAssociate = displayTypeData
            }
            this.apiserve.sendevent("FestivalVillage|Partner|getList", data);
        });
    }

    clearFn = () => {
        if (this.state.changeTitleName === true) {
            this.setState({
                contactFullName: "",
                lastName: "",
                partnerName: "",
                base64: null,
                partnerLogo: "",
                partnerSubTitle: "",
                instituteAssociate: false,
                selectedDropdown: "Select an Option"
            })
        } else {
            this.setState({
                contactFullName: "",
                lastName: "",
                email: "",
                partnerName: "",
                partnerLogo: "",
                selectedDropdown: "Select an Option",
                base64: null,
                instituteAssociate: false,
                partnerSubTitle: ""
            })
        }

    }

    handleUncheck = (e) => {
        const { name, checked } = e.target;
        this.setState({
            instituteAssociate: checked
        })
    }

    deleteImagePopup = () => {
        this.setState({
            partnerLogo: '',
            deleteImagePopup: false,
        })
    }

    deleteImage() {
        this.setState({
            deleteImagePopup: true,
        })
    }

    closeAdminUser = () => {
        this.setState({
            deleteImagePopup: false
        });
    };

    downloadcsv = () => {
        var data = {
            role: 'partner'
        }
        this.apiserve.sendevent("FestivalVillage|getUserCsv", data);
    }


    render() {
        const { createPartnerPopup, getAllPartnersDetails, getAllPartnersdocs, changeTitleName } = this.state
        return (
            <React.Fragment>
                <div className="right_side_wrapper partnerView_wrapper adminDashboard_wrapper">
                    <div className="dashboard_header with_btn">
                        <div className="searchBlock">
                            <span>Partners ( {getAllPartnersDetails.totalDocs} )</span>
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    id="searchField"
                                    name="searchField"
                                    value={this.state.searchField}
                                    onChange={this.onSearchFilter}
                                    autoComplete="off"
                                />
                                <button type="submit" style={{ pointerEvents: 'none' }}>
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>
                        <div className="button_block admin_user_twoBtn">
                            <div className="icon_block">
                                <Link onClick={() => this.downloadcsv()}><img src={cloud} /></Link>
                            </div>
                            <Link className="head_btn"
                                onClick={() => this.createPartnersUser()}>
                                Add Partner
                                </Link>
                        </div>
                    </div>
                    <div className="dashboard_data">
                        <div className="dashboard_data_table">
                            <table>
                                <thead>
                                    {this.getPartnerTableHeadView()}
                                </thead>
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided, snapshot) => (
                                            <tbody {...provided.droppableProps} ref={provided.innerRef} >
                                                {getAllPartnersdocs.map((item, index) => {
                                                    return (
                                                        <Draggable
                                                            key={item._id}
                                                            draggableId={`'${item._id}'`}
                                                            index={index}
                                                        >
                                                            {(provided, snapshot) => (
                                                                <tr ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}>
                                                                    <>
                                                                    <td className="user_email_d partnerName_d "> <span className="user_status">
                                                                        <svg className="active" xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" viewBox="0 0 8 8"><circle cx="1" cy="1" r="1" fill="#666"></circle><circle cx="1" cy="4" r="1" fill="#666"></circle><circle cx="1" cy="7" r="1" fill="#666"></circle><circle cx="4" cy="1" r="1" fill="#666"></circle><circle cx="4" cy="4" r="1" fill="#666"></circle><circle cx="4" cy="7" r="1" fill="#666"></circle><circle cx="7" cy="1" r="1" fill="#666"></circle><circle cx="7" cy="4" r="1" fill="#666"></circle><circle cx="7" cy="7" r="1" fill="#666"></circle></svg>
                                                                    </span>  {item.partnerName}</td>
                                                                    <td className="" style={{ width: "200px" }}>{item.contactFullName}</td>
                                                                    <td className="lastName_d" style={{ width: "270px" }}>{item.email}</td>
                                                                    <td className="regOn_d" style={{ width: "150px" }}>{moment(item.updatedAt).format('MM/DD/YYYY')}</td>
                                                                    <td className="addOn_d" style={{ width: "150px" }}>{moment(item.createdAt).format('MM/DD/YYYY')}</td>
                                                                    <td className="p_0" style={{ width: "220px" }}>
                                                                        <div className="icon_d p_0 w_100">
                                                                            <Link onClick={() => this.editPartnersUser(item)}>
                                                                                <EditIcon />
                                                                                <div>edit</div>
                                                                            </Link>
                                                                            {item.isBlocked ?
                                                                                <Link onClick={() => this.unblockPartnersUser(item)}>
                                                                                    <LockIcon /> <div>lock</div>
                                                                                </Link>
                                                                                :
                                                                                <Link onClick={() => this.blockPartnersUser(item)}>
                                                                                    <LockCloseIcon /><div>unlock</div>
                                                                                </Link>
                                                                            }
                                                                            <Link onClick={() => this.deletePartnersUser(item)}>
                                                                                <DeleteIcon /><div>delete</div>
                                                                            </Link>
                                                                            <Link onClick={() => this.changeRouteUser(item)}>
                                                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E" />
                                                                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E" />
                                                                                </svg>
                                                                            </Link>
                                                                            {item.verified ? '' :
                                                                                <Link className="check_admin" onClick={() => this.sendEmailPopup(item)}>
                                                                                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                                                    </svg>
                                                                                    <span className="tooltip_box">Send invitation email</span>
                                                                                </Link>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    </>
                                                                </tr>
                                                            )}
                                                        </Draggable>
                                                    )
                                                }
                                                )}
                                            </tbody>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </table>
                        </div>
                    </div>
                    {createPartnerPopup ?
                        <div className="popup_wrapper partner-event-popup" style={{ maxWidth: "568px" }}>
                            <h2>
                                {changeTitleName ? "Edit MS Partner" : "Create New MS Partner"}
                                <img src={close} onClick={() => this.closePartnerUser()} />
                            </h2>
                            <form>
                                <div className="details">
                                    <div className="partnerLogo">
                                        <label>Partner Logo<span>(optional)</span></label>
                                        <div className='image_pre_loader'>
                                            <input id="myInput"
                                                type="file"
                                                ref={(ref) => this.upload = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFile.bind(this)}
                                                accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader ?
                                                <Loader />
                                                :
                                                <img src={this.state.partnerLogo ?
                                                    this.apiserve.imageUrl + this.state.partnerLogo :
                                                    background
                                                } />
                                            }
                                            <a className={this.state.partnerLogo ? "add_file_img active" : 'add_file_img'} onClick={() => { this.upload.click() }}><img src={plusIcon} /></a>
                                            {this.state.partnerLogo ?
                                                <span className="remove_file pointer"
                                                    onClick={() => this.deleteImage()}
                                                ><DeletefileIcon /></span> : ''}

                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label>Partner Name</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="partnerName"
                                                id="partnerName"
                                                value={this.state.partnerName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('partner name', this.state.partnerName, 'required')}</span>
                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label>Contact Email</label>
                                        <div className="form_group_input">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                disabled={this.state.changeTitleName ? true : false}
                                                maxLength={255}
                                                value={this.state.email}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('email', this.state.email, 'required|email')}</span>
                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label>Contact Full Name</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="contactFullName"
                                                id="contactFullName"
                                                value={this.state.contactFullName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('contactFullName', this.state.contactFullName, 'required')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN"
                                        type="button"
                                        onClick={() => this.clearFn()}
                                    >Clear</button>
                                    <button className="orangeBTN"
                                        type="button"
                                        disabled={this.state.imagePreloader ? true : false}
                                        onClick={(e) => this.submitFn(e)}
                                    >Submit</button>
                                </div>
                            </form>
                        </div>
                        : ''}
                </div>

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {/* For resend Mail */}
                <div className={`user_popup ${this.state.resendMailPopup ? "active" : ''}`}>
                    <span className="popup_overlay" onClick={this.closePartnerUser}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>Do you want to send the invitation email to {this.state.userContactFullName} again?</p>
                            <span className="close_popup" onClick={this.closePartnerUser}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                </svg>
                            </span>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="" onClick={this.closePartnerUser}>OK</button>
                                <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(partnerViewEvent)